export default "__VITE_ASSET__6hmoRoq7__"